import Joyride, { Step, CallBackProps, STATUS, ACTIONS } from 'react-joyride';

interface TourWrapperProps {
  steps: Step[];
  run: boolean;
  onComplete: () => void;
  onSkip: () => void;
}

const TourWrapper = ({ steps, run, onComplete, onSkip }: TourWrapperProps) => {
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action } = data;
    
    if (status === STATUS.FINISHED) {
      onComplete();
    } else if (status === STATUS.SKIPPED || action === ACTIONS.CLOSE) {
      onSkip();
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes tooltipFadeIn {
            0% {
              opacity: 0;
              transform: translateY(10px) scale(0.95);
            }
            100% {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          
          @keyframes spotlightPulse {
            0%, 100% {
              box-shadow: 0 0 40px rgba(255, 215, 0, 0.6), 0 0 80px rgba(255, 215, 0, 0.3);
            }
            50% {
              box-shadow: 0 0 50px rgba(255, 215, 0, 0.8), 0 0 100px rgba(255, 215, 0, 0.4);
            }
          }
          
          .react-joyride__tooltip {
            animation: tooltipFadeIn 0.4s ease-out forwards !important;
          }
          
          .react-joyride__spotlight {
            animation: spotlightPulse 2s ease-in-out infinite !important;
          }
        `}
      </style>
      <Joyride
        steps={steps}
        run={run}
        continuous
        showProgress
        showSkipButton
        disableOverlayClose
        spotlightClicks
        callback={handleJoyrideCallback}
        floaterProps={{
          styles: {
            floater: {
              filter: 'none',
            },
            wrapper: {
              animation: 'tooltipFadeIn 0.4s ease-out forwards',
            },
          },
          disableAnimation: false,
        }}
        styles={{
        options: {
          backgroundColor: '#1a1f2e',
          arrowColor: '#1a1f2e',
          overlayColor: 'rgba(8, 12, 20, 0.90)',
          primaryColor: '#ffd700',
          textColor: '#ffffff',
          spotlightShadow: '0 0 40px rgba(255, 215, 0, 0.6), 0 0 80px rgba(255, 215, 0, 0.3)',
          zIndex: 10000,
        },
        buttonNext: {
          backgroundColor: '#ffd700',
          color: '#080c14',
          fontWeight: 600,
          borderRadius: '0.5rem',
          padding: '0.625rem 1.25rem',
          boxShadow: '0 0 20px rgba(255, 215, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)',
          transition: 'all 0.3s ease',
        },
        buttonBack: {
          color: '#ffffff',
          marginRight: '0.5rem',
          padding: '0.625rem 1rem',
          borderRadius: '0.5rem',
          transition: 'all 0.3s ease',
        },
        buttonSkip: {
          color: '#9ca3af',
          padding: '0.625rem 1rem',
          borderRadius: '0.5rem',
          transition: 'all 0.3s ease',
        },
        tooltip: {
          borderRadius: '1rem',
          padding: '1.5rem',
          backgroundColor: '#1a1f2e',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(255, 215, 0, 0.15), inset 0 0 0 1px rgba(255, 215, 0, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 215, 0, 0.2)',
          transition: 'all 0.3s ease-out',
          transformOrigin: 'top center',
        },
        tooltipContent: {
          padding: '0.5rem 0',
          fontSize: '0.9375rem',
          lineHeight: '1.6',
        },
        tooltipTitle: {
          fontSize: '1.125rem',
          fontWeight: 600,
          marginBottom: '0.5rem',
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip Tour',
      }}
      />
    </>
  );
};

export default TourWrapper;
